import { C, ff, t } from '../../Dashboard/components/dashboardConstants';

export default function DetailTimeline({ items }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
      <div style={{
        background: C.white, border: `1px solid ${C.g200}`,
        borderRadius: '16px', padding: '22px 20px',
        position: 'relative',
      }}>
        <h2 style={{ ...t('16px', 700, C.bk), margin: '0 0 18px 0' }}>진행 타임라인</h2>
        {/* 세로 점선: 첫 도트 아래 ~ 마지막 도트 위 */}
        {items.length > 1 && (
          <div style={{
            position: 'absolute',
            left: '29px',
            top: '50px',
            bottom: '50px',
            width: 0,
            borderLeft: '1.5px dashed #D8D8E0',
          }} />
        )}

        <div style={{ display: 'flex', flexDirection: 'column', gap: '28px' }}>
          {items.map((item, i) => {
            const isCurrent = i === items.length - 1;
            return (
              <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '14px' }}>
                {/* 도트 */}
                <div style={{
                  width: '20px', flexShrink: 0,
                  display: 'flex', justifyContent: 'center',
                  paddingTop: '3px', position: 'relative', zIndex: 1,
                }}>
                  <div style={{
                    width: isCurrent ? '12px' : '10px',
                    height: isCurrent ? '12px' : '10px',
                    borderRadius: '50%',
                    background: isCurrent ? '#FFB517' : '#D0D0D8',
                    boxShadow: isCurrent ? '0 0 0 4px rgba(255,181,23,0.2)' : 'none',
                    marginTop: isCurrent ? '0' : '1px',
                  }} />
                </div>

                {/* 텍스트 */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                  {item.date && (
                    <span style={{
                      fontFamily: ff, fontSize: '12px', fontWeight: 400,
                      color: C.sub, letterSpacing: '-0.03em',
                    }}>
                      {item.date}
                    </span>
                  )}
                  <span style={{
                    fontFamily: ff, fontSize: '14px', fontWeight: 700,
                    color: isCurrent ? '#FFB517' : C.bk,
                    letterSpacing: '-0.03em', lineHeight: '140%',
                  }}>
                    {item.label}
                  </span>
                  {item.desc && (
                    <span style={{
                      fontFamily: ff, fontSize: '13px', fontWeight: 400,
                      color: C.sub, letterSpacing: '-0.03em', lineHeight: '150%',
                    }}>
                      {item.desc}
                    </span>
                  )}
                  {item.dueDate && (
                    <span style={{
                      fontFamily: ff, fontSize: '12px', fontWeight: 500,
                      color: '#FFAB20', letterSpacing: '-0.03em',
                    }}>
                      마감: {item.dueDate}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

